import { ITableColumn } from '@components/common/UTable/UTable';

import { Dictionaries } from '@/api/dictionaries/types';
import { IndividualSexLabel, IndividualStatusLabel } from '@/shared/vaccination/enums';
import { dictToOptions, enumToOptions } from '@/utils/utils';

export const columns = (dictionaries?: Dictionaries): ITableColumn[] => [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Инвентарный номер',
    dataIndex: 'inventoryNumber',
    sorter: true,
  },
  {
    title: 'Объект',
    dataIndex: 'individualLocationId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.INDIVIDUAL_LOCATION),
    },
    sorter: true,
  },
  {
    title: 'Дата рождения',
    dataIndex: 'birthDate',
    type: 'date',
    sorter: true,
  },
  {
    title: 'Статус',
    dataIndex: 'individualStatus',
    type: 'select',
    payload: {
      options: enumToOptions(IndividualStatusLabel),
    },
    sorter: true,
  },
  {
    title: 'Вид животного',
    dataIndex: 'animalSpeciesId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.ANIMAL_SPECIES),
    },
    sorter: true,
  },
  {
    title: 'Пол',
    dataIndex: 'sex',
    type: 'select',
    payload: {
      options: enumToOptions(IndividualSexLabel),
    },
    sorter: true,
  },
];
